















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class GlobalLoading extends Vue {
  @Prop({ default: true }) readonly value!: boolean

  // private me_checked = this.value
  // watch: {
  //   value(val) {
  //   }
  // }
  toggle () {
    this.$emit('input', this.value)
  }
}
